var EHDI = EHDI || Object.create(null);

EHDI.util = EHDI.util || Object.create(null);

EHDI.util.Trigo = Object.create(null);

EHDI.util.Trigo.getAngleOfOppositeAndAdjacent = function (opposite, adjacent) {
  return Math.atan(opposite / adjacent);
}

EHDI.util.Trigo.getAngleOfOppositeAndHypotenuse = function (opposite, hypotenuse) {
  return Math.atan(opposite / hypotenuse);
}

EHDI.util.Trigo.getAngleOfAdjacentAndHypotenuse = function (adjacent, hypotenuse) {
  return Math.atan(adjacent / hypotenuse);
}

EHDI.util.Trigo.convertRadianToDegree = function (radian) {
  var degree = radian * (180 / Math.PI);

	return EHDI.util.Trigo.floatRound(degree, 4);
}

EHDI.util.Trigo.convertDegreeToRadian = function (degree) {
  var radian = degree / (180 / Math.PI);

	return EHDI.util.Trigo.floatRound(radian, 4);
}

EHDI.util.Trigo.floatRound = function (number, precision) {
  var decimalPlaces = Math.pow( 10, precision );
	return Math.round( decimalPlaces * number) / decimalPlaces;
}

EHDI.util.Trigo.getHypotenuseUsingOppositeAndAdjacent = function (opposite, adjaccent) {
  return EHDI.util.Trigo.floatRound(Math.sqrt((Math.pow(opposite, 2) +Math.pow(adjaccent, 2))), 4);
}

EHDI.util.Trigo.getUnitCircleAngle = function (startPoint, endPoint) {
  var deltaX = endPoint.x - startPoint.x;
  var deltaY = endPoint.y - startPoint.y;

  var angleToReturn;

  if (deltaX == 0 && deltaY == 0)
  {
    angleToReturn = -1;
  }
  else
  {
    var angleInDegree = EHDI.util.Trigo.convertRadianToDegree(EHDI.util.Trigo.getAngleOfOppositeAndAdjacent(deltaX, deltaY));
    angleInDegree = Math.abs(angleInDegree);

    //quadrant 4
    if (deltaX >= 0 && deltaY >= 0)
    {
      //trace("4");
      angleToReturn = 90-angleInDegree;
    }
    //quadrant 3
    else if (deltaX < 0 && deltaY >= 0)
    {
      //trace("3");
      angleToReturn = angleInDegree + 90;
    }
    //quadrant 2
    else if (deltaX < 0 && deltaY < 0)
    {
      //trace("2");
      angleToReturn = -angleInDegree + 270;
    }
    //quadrant 1
    else
    {
      //trace("1");
      angleToReturn = angleInDegree+ 270;
    }
  }

  return angleToReturn;
}
